import React from 'react';
import { FormattedMessage } from 'react-intl';

const TermsOfService = () => (
  <div className="row">
    <div className="col-xs-12 margin-bottom-sm-10 margin-bottom-xs-20 margin-top-20 text-color-dark-slate text-weight-book text-size-14">
      <FormattedMessage
        id="checkout.purchase-terms-prefix"
        defaultMessage="By purchasing, you accept our "
      />
      <a href="/support/terms/" target="_blank" rel="noopener noreferrer" className="text-weight-medium">
        <FormattedMessage
          id="common.terms-and-privacy"
          defaultMessage="Terms of Service & Privacy Policy"
        />.
      </a>
    </div>
  </div>
);

export default TermsOfService;
